import React  from "react"
import styled from "styled-components";
import { suffixToNumber } from "../../lib/utils";

const UpperTagDiv = styled.div`
    background-color: var(--Dove);
    padding: 24px 24px 0 32px;
    display: flex;
    gap: 24px;
    width: 100%;
`
const Tag = styled.div`
    width: max-content;
    position: relative;
    background: ${({ isScheduledTag }) => isScheduledTag ?  'rgba(52, 211, 153, 0.2)' : 'rgba(253, 186, 116, 0.5)'};
    border: 1px solid ${({ isScheduledTag }) => isScheduledTag ?  'rgba(52, 211, 153, 0.4)' : 'rgba(180, 83, 9, 0.4)'};
    border-radius: 32px;
    padding: 8px;
    cursor: pointer;
    @media(max-width:460px){
        width: 48%;
    }

`
const TagText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    margin-left: 16px;
    color:  ${({ isScheduledTag }) => isScheduledTag ?  '#10B981' : '#B45309'};
    
`

const Icons = styled.img`
    position: absolute;
    top: -4px;
    left: -20px;
`

const LeaderboardTags = ({ authorRankData, contestData, history }) => (
    
      <UpperTagDiv>
            {authorRankData?.author_rank_in_new ? <Tag onClick={() => history.push(`/contest/${contestData?.contest_title}-${contestData?.contest_id}?defaultLeaderboardTab=new`)}>
                <Icons src="/images/trending_filled.svg" />
                <TagText>{suffixToNumber(authorRankData?.author_rank_in_new || 0)} in {contestData?.contest_title}</TagText>
            </Tag> : 
            authorRankData?.author_rank_in_popular ? <Tag onClick={() => history.push(`/contest/${contestData?.contest_title}-${contestData?.contest_id}?defaultLeaderboardTab=popular`)}>
                <Icons src="/images/trending_burn_icon.svg" />
                <TagText>{suffixToNumber(authorRankData?.author_rank_in_popular || 0)} in {contestData?.contest_title}</TagText>
            </Tag> : <></>}
            {authorRankData?.author_rank_in_scheduled && <Tag onClick={() => history.push(`/contest/${contestData?.contest_title}-${contestData?.contest_id}?defaultLeaderboardTab=scheduled`)} isScheduledTag >
                <Icons src="/images/green_clock.svg" />
                <TagText isScheduledTag >{suffixToNumber(authorRankData?.author_rank_in_scheduled || 0)} in Scheduled Days</TagText>
            </Tag>}
        </UpperTagDiv>
)

export default LeaderboardTags